import { customFetch } from "../utils/http"

export const getDashboardMonthlySales = (year : number) => {
    return customFetch(`v1/dashboard/monthly-sales?year=${year}`, {
      method: "GET",
    })
}
export const getTopMerchants = (limit : number) => {
    return customFetch(`v1/dashboard/top-merchant?limit=${limit}`, {
      method: "GET",
    })
}
export const getTopCustomers = (limit : number) => {
    return customFetch(`v1/dashboard/top-customer?limit=${limit}`, {
      method: "GET",
    })
}
export const getTopProducts = (limit : number) => {
    return customFetch(`v1/dashboard/top-product?limit=${limit}`, {
      method: "GET",
    })
}